export default __webpack_public_path__ + "static/media/keller-user-flow-main.b1b4fdc3.png";